import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MakerDashboardModel } from '../model/MakerDashboardModel';
import { CheckerDashboardModel } from '../model/CheckerDashboardModel';
import { AdminDashboardModel } from '../model/AdminDashboardModel';
import { InternalModeratorDashboardModel } from '../model/InternalModeratorDashboardModel';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NodalOfficerDashboardModel } from '../model/NodalOfficerDashboardModel';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  fetchMakerDashboard() {
    return this.httpClient.get<MakerDashboardModel>(ApiUrls.home);
  }
  
  fetchCheckerDashboard() {
    return this.httpClient.get<CheckerDashboardModel>(ApiUrls.home);
  }

  fetchAdminDashboard() {
    return this.httpClient.get<AdminDashboardModel>(ApiUrls.home);
  }

  fetchInternalModeratorDashboard() {
    return this.httpClient.get<InternalModeratorDashboardModel>(ApiUrls.home);
  }

  fetchModerationInchargeDashboard() {
    // return this.httpClient.get<ModerationInchargeDashboardModel>(ApiUrls.home);
  }

  fetchNOCDashboard() {
    // return this.httpClient.get<NocDashboardModel>(ApiUrls.nocDashboard);
  }

  fetchNodalOfficerDashboard() {
    return this.httpClient.get<NodalOfficerDashboardModel>(ApiUrls.home);
  }

  assignModerationCases(data: number) {
    return this.httpClient.get<{status: string, errorMessage: string}>(
      ApiUrls.assignModerationCasesUrl+'?data='+data);
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
}
